module.exports = __webpack_public_path__ + "static/media/info-active.c37e33a8.svg";